import constants from "./constants"
import mimeTypes from "./mimeTypes.json"
import { toast } from "react-toastify";
import { DateTime } from "luxon"
const BASE_URL = "https://airbook.netlify.app";
const API_URL = BASE_URL + "/api/";
const ROLES = constants().ROLES;
console.log(ROLES);
export const getUserBaseUrl = (role, onlyPath) => {
    if (role === ROLES.SUPER_ADMIN) {
        return onlyPath ? "/super-admin" : (API_URL + "super-admin");
    }
    else if (role === ROLES.ADMIN) {
        return onlyPath ? "/admin" : (API_URL + "admin");
    }
    else if (role === ROLES.CO) {
        return onlyPath ? "/coo" : (API_URL + "coo");
    }
    else if (role === ROLES.FACULTY) {
        return onlyPath ? "/faculty" : (API_URL + "faculty");
    }
    else if (role === ROLES.CR) {
        return onlyPath ? "/cr" : (API_URL + "cr");
    }
    else if (role === ROLES.STUDENT) {
        return onlyPath ? "/student" : (API_URL + "student");
    }
    else {
        throw Error("No such role found");
    }
}
// export  getUserBaseUrl;


/**
 *
 * @param {Number} academicYear - academic year eg: 2
 * @param {Date} [currentDate=DateTime.now().toUTC().toISO()] - UTC based ISO string[optional]
 * @param {eoa} eoa - end of academic year date UTC based ISO string
 * @returns {Number}  returns year of the batch eg:2018
 */
export const findBatch = (academicYear, currentDate, eoa) => {
    // converts currentDate,eoa to utc 
    if (!currentDate) {
        currentDate = DateTime.now().toUTC().toISO();
    }
    // IST is no need
    // const curr_date = DateTime.fromISO(currentDate).setZone("Asia/Kolkata");
    const eoaDateTime = DateTime.fromJSDate((new Date(eoa)));
    const academicEndDate = {
        month: eoaDateTime.month,
        date: eoaDateTime.day
    }
    const curr_date = DateTime.fromISO(currentDate).toUTC();
    const pres_year = curr_date.year;
    // 10min adding
    const end_date = DateTime.fromObject({
        year: pres_year,
        month: academicEndDate.month,
        day: academicEndDate.date,
        minute: 10,
    }).toUTC();

    const diff = end_date
        .diff(curr_date, [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds",
        ])
        .toObject();
    // after completing end_sem_date
    if (
        diff.months <= 0 &&
        diff.days <= 0 &&
        diff.hours <= 0 &&
        diff.minutes <= 0
    ) {
        return curr_date.year - academicYear + 1;
    }
    return curr_date.year - academicYear;
};

/**
 * 
 * @param {Number} start - start number
 * @param {Number} end - end number
 * @returns {Array}  range of numbers inclusive
 */
export const range = (start, end) => {
    return Array(end - start + 1).fill().map((_, idx) => start + idx)
}

const getUrlFromMimeType = (type, getAs, id) => {
    if (getAs === 'preview') {
        return `https://drive.google.com/file/d/${id}/preview`
    }
    if (getAs === 'print' || type === 'media') {
        if (type === 'unknown') {
            return false;
        }
        if (type === 'doc') {
            return `https://docs.google.com/document/d/${id}/export?format=pdf`;
        }
        if (type === 'ppt') {
            return `https://docs.google.com/feeds/download/presentations/Export?id=${id}&exportFormat=pdf`;
        }
        if (type === 'pdf') {
            return `https://drive.google.com/uc?export=download&id=${id}&confirm=t`;
        }
    }
    if (getAs === 'download') {
        if (type === 'doc') {
            return `https://docs.google.com/document/d/${id}/export?format=doc`;
        }
        if (type === 'pdf') {
            return `https://drive.google.com/uc?export=download&id=${id}`;
        }
        if (type === 'ppt') {
            return `https://docs.google.com/feeds/download/presentations/Export?id=${id}&exportFormat=ppt`;
        }
        if (type === 'media' || type === 'unknown') {
            return `https://drive.google.com/uc?export=download&id=${id}&confirm=t`;
        }
    }
}

/**
 * 
 * @param {String} mimeType - mimeType of the drive file
 * @param {String} id - drive file ID
 * @returns {Object} - {download, print, preview }
 */
export const getDriveFileUrl = (mimeType, id) => {
    const foundMime = mimeTypes.types.filter(type => type.mimeType === mimeType)[0];
    console.log(foundMime);
    if (!foundMime) {
        console.log(mimeType);
        return false;
    };
    return {
        download: getUrlFromMimeType(foundMime.type, 'download', id),
        print: getUrlFromMimeType(foundMime.type, 'print', id),
        preview: getUrlFromMimeType(foundMime.type, 'preview', id)
    }
}

export const getNavLinks = (role) => {
    const navLinks = {
        profile: "/profile"
    };
    if (role === ROLES.SUPER_ADMIN) {
        return { ...navLinks, home: "/super-admin", addRole: [] };
    }
    else if (role === ROLES.ADMIN) {
        return { ...navLinks, home: "/admin", addRole: [{ url: "/adminAddSubject", title: "Add Subjects" }] };
    }
    else if (role === ROLES.CO) {
        // return { ...navLinks, home: "/coo", addRole: [{ url: "/add-faculty", title: "Add Faculty" }, { url: "/add-cr", title: "Add CR" }] };
        return { ...navLinks, home: "/coo", addRole: [] };
    }
    else if (role === ROLES.FACULTY) {
        return { ...navLinks, home: "/faculty", addRole: [] };
    }
    else if (role === ROLES.CR) {
        return { ...navLinks, home: "/student", addRole: [], upload: "/cr-upload" };
    }
    else if (role === ROLES.STUDENT) {
        return { ...navLinks, home: "/student", addRole: [] };
    }
    else {
        new Error("No such  role found");
    }
}

export const handleXhrError = (jqXHR, exception, err, cb) => {
    let msg = '';
    if (jqXHR.status === 0) {
        msg = 'Not connect.\n Verify Network.';
    }
    else if (jqXHR.status == 500) {
        msg = 'Internal Server Error [500].';
    }
    else if (exception === 'parsererror') {
        msg = 'Requested JSON parse failed.';
    }
    else if (exception === 'timeout') {
        msg = 'Time out error.';
    } else if (exception === 'abort') {
        msg = 'Ajax request aborted.';
    }
    //  else {
    //     msg = 'Uncaught Error.\n' + jqXHR.responseText;
    // }
    msg.length > 0 && toast.error(msg);
    cb();
}